import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Popover,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  CustomInput,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  UncontrolledPopover,
  PopoverHeader
} from 'reactstrap';
import DropZone from 'react-dropzone';
import { ChromePicker, CirclePicker, SketchPicker } from 'react-color';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import { ImageCard } from '../../../commons/controls';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './HelyszinTooltips';
import Lib from '../../../commons/lib';

class PubszinContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      currentId: undefined,
      torlesId: undefined,
      // MODAL UTILS
      modalForm: false,
      modalDelete: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      // FORM VALUES
      isElsodlegesPickerOpen: false,
      isMasodlagosPickerOpen: false,
      formSzinkodFejlec: '',
      formSzinkodLablec: '',
      formSzinkodElsodleges: '',
      formSzinkodMasodlagos: '',
      formHelyszin: '',
      formHelyszinOptions: [],
      formTema: '',
      formLogo: null,
      formTemaOptions: []
    };
  }

  componentDidMount() {
    //this.initPublikusSzinForm();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) this.listPublikusSzin();
    }
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm, formLogo: null }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleElsodlegesPicker = () => {
    this.setState(prevState => ({ isElsodlegesPickerOpen: !prevState.isElsodlegesPickerOpen }));
  }

  toggleMasodlagosPicker = () => {
    this.setState(prevState => ({ isMasodlagosPickerOpen: !prevState.isMasodlagosPickerOpen }));
  }

  renderHelyszinOptions = () => {
    return this.state.formHelyszinOptions.map((helyszin) => {
      return <option value={helyszin.helyszinid}>{helyszin.helyszinnev}</option>
    });
  }

  renderTemaOptions = () => {
    return this.state.formTemaOptions.map((tema) => {
      return <option value={tema.name}>{tema.caption}</option>
    });
  }

  getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if ((cBrightness > threshold) || (hex === '#') || (hex === '#null')) { return '#000000'; } return '#ffffff';
  }

  listPublikusSzin = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listPublikusSzin((err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  initPublikusSzinForm = () => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.initPublikusSzinForm((err, res) => {
      if (!err) {
        this.setState({
          formStatus: 'DATA',
          formHelyszinOptions: res[0].helyszin,
          formTemaOptions: res[0].tema
        }, () => {

        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  getPublikusSzin = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.initPublikusSzinForm((err, res) => {
      if (!err) {
        this.setState({
          formHelyszinOptions: res[0].helyszin,
          formTemaOptions: res[0].tema
        }, () => {
          Services.getPublikusSzin(id, (err, res) => {
            if (!err) {
              this.setState({
                formStatus: 'DATA',
                formLogo: res[0].objectparamlist ? res[0].objectparamlist[0] : null,
                formHelyszin: this.nullToString(res[0].helyszinid),
                formTema: this.nullToString(res[0].tema.name),
                formSzinkodFejlec: this.nullToString(res[0].fejlecszin),
                formSzinkodLablec: this.nullToString(res[0].lablecszin),
                formSzinkodElsodleges: this.nullToString(res[0].elsodlegesszin),
                formSzinkodMasodlagos: this.nullToString(res[0].masodlagosszin),
              });
            } else {
              this.setState({
                formStatus: 'NETW'
              });
            }
          });
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleColorFejlecChange = (color) => {
    this.setState({ formSzinkodFejlec: color.hex.substr(1, 6) });
  }

  handleColorLablecChange = (color) => {
    this.setState({ formSzinkodLablec: color.hex.substr(1, 6) });
  }

  handleColorChange = (color) => {
    this.setState({ formSzinkodElsodleges: color.hex.substr(1, 6) });
  }

  handleColorMasodlagosChange = (color) => {
    this.setState({ formSzinkodMasodlagos: color.hex.substr(1, 6) });
  }

  handleEditClick = (cell) => {
    this.setState({
      formType: 'MOD',
      currentId: cell,
      modalForm: true
    }, () => {
      this.getPublikusSzin(cell);
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleDeleteModal();
    });
  }

  deletePublikusSzin = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deletePublikusSzin(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listPublikusSzin();
        this.props.globals.addSuccess('Színséma törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formStatus: 'LOAD',
      formTema: '',
      formHelyszin: '',
      formSzinkodFejlec: '',
      formSzinkodLablec: '',
      formSzinkodElsodleges: '',
      formSzinkodMasodlagos: '',
    }, () => {
      this.toggleFormModal();
      this.initPublikusSzinForm();
    });
  }

  submitForm = () => {
    const {
      currentId,
      formNev,
      formNevEn,
      formAzonosito,
      formHelyszin,
      formTema,
      formSzinkodFejlec,
      formSzinkodLablec,
      formSzinkodElsodleges,
      formSzinkodMasodlagos,
      formAkadalymentesitett,
      formHasznalhato,
      formType
    } = this.state;

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {
      let submitObj = {};
      let objects = [];
      objects.push(this.state.formLogo);
      submitObj.objectparamlist = objects;
      submitObj.fejlecszin = this.emptyOrNull(formSzinkodFejlec);

      if (submitObj.fejlecszin && (submitObj.fejlecszin.charAt(0) === '#')) {
        submitObj.fejlecszin = submitObj.fejlecszin.substring(1);
      }

      submitObj.lablecszin = this.emptyOrNull(formSzinkodLablec);

      if (submitObj.lablecszin && (submitObj.lablecszin.charAt(0) === '#')) {
        submitObj.lablecszin = submitObj.lablecszin.substring(1);
      }

      submitObj.elsodlegesszin = this.emptyOrNull(formSzinkodElsodleges);

      if (submitObj.elsodlegesszin && (submitObj.elsodlegesszin.charAt(0) === '#')) {
        submitObj.elsodlegesszin = submitObj.elsodlegesszin.substring(1);
      }

      submitObj.masodlagosszin = this.emptyOrNull(formSzinkodMasodlagos);

      if (submitObj.masodlagosszin && (submitObj.masodlagosszin.charAt(0) === '#')) {
        submitObj.masodlagosszin = submitObj.masodlagosszin.substring(1);
      }

      submitObj.helyszinid = this.emptyOrNull(formHelyszin);
      submitObj.tema = this.emptyOrNull(formTema);

      Services.insertPublikusSzin(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Színséma felvéve!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listPublikusSzin();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    } else if (formType === 'MOD') {
      let submitObj = {};
      let objects = [];
      if(this.state.formLogo) objects.push(this.state.formLogo);
      submitObj.objectparamlist = objects;
      submitObj.id = this.emptyOrNull(currentId);

      submitObj.fejlecszin = this.emptyOrNull(formSzinkodFejlec);

      if (submitObj.fejlecszin && (submitObj.fejlecszin.charAt(0) === '#')) {
        submitObj.fejlecszin = submitObj.fejlecszin.substring(1);
      }

      submitObj.lablecszin = this.emptyOrNull(formSzinkodLablec);

      if (submitObj.lablecszin && (submitObj.lablecszin.charAt(0) === '#')) {
        submitObj.lablecszin = submitObj.lablecszin.substring(1);
      }
      submitObj.elsodlegesszin = this.emptyOrNull(formSzinkodElsodleges);

      if (submitObj.elsodlegesszin && (submitObj.elsodlegesszin.charAt(0) === '#')) {
        submitObj.elsodlegesszin = submitObj.elsodlegesszin.substring(1);
      }

      submitObj.masodlagosszin = this.emptyOrNull(formSzinkodMasodlagos);

      if (submitObj.masodlagosszin && (submitObj.masodlagosszin.charAt(0) === '#')) {
        submitObj.masodlagosszin = submitObj.masodlagosszin.substring(1);
      }

      submitObj.helyszinid = this.emptyOrNull(formHelyszin);
      submitObj.tema = this.emptyOrNull(formTema);

      Services.modifyPublikusSzin(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Színséma módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listPublikusSzin();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }

  onDropLogo = (acceptedfiles) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files = this.state.formLogo || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          type: 'LOGO',
          preview: file.preview,
          logo: false,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
          // id: Lib.Browser.uuidv4(),
        });
        this.setState({ formLogo: files[0] });
      };
      reader.readAsBinaryString(file);
    });
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
            {'Módosítás'}
          </UncontrolledTooltip>
          <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'file'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'file'} delay={50}>
            {'Törlés'}
          </UncontrolledTooltip>
        </React.Fragment>
      </div>
    );
  }

  tableBooleanFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-danger">Nem</span>;
  }

  styleSzinkod = (szinkod) => {
    return {
      textAlign: 'center',
      whiteSpace: 'pre-line',
      backgroundColor: '#' + szinkod,
      color: this.getCorrectTextColor('#' + szinkod)
    };
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új beállítások rögzítése';
      case 'MOD':
        return 'Beállítások módosítása';
      default:
        return '';
    }
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const selectOptions = {
      true: 'Igen',
      false: 'Nem',
    };

    const columns = [
      {
        dataField: 'helyszinnev',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'tema',
        text: 'Téma',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'elsodlegesszin',
        text: 'Elsődleges szín',
        style: this.styleSzinkod,
        formatter: (cell) => { return '#' + cell; },
        sort: true
      },
      {
        dataField: 'masodlagosszin',
        text: 'Másodlagos szín',
        style: this.styleSzinkod,
        formatter: (cell) => { return '#' + cell; },
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  renderForm = () => {
    const {
      isElsodlegesPickerOpen,
      isMasodlagosPickerOpen,
      formNev,
      formNevEn,
      formAzonosito,
      formSzinkodFejlec,
      formSzinkodLablec,
      formSzinkodElsodleges,
      formSzinkodMasodlagos,
      formAkadalymentesitett,
      formHasznalhato,
      formType,
      formHelyszin,
      formTema
    } = this.state;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            <RFField
              type="select"
              name="formHelyszin"
              id="formHelyszin"
              label="Helyszín: *"
              errorMessage="Kötelező mező!"
              required
              value={formHelyszin}
              onChange={this.handleInputChange}
              autocomplete="off"
              defaultSelect={<option value="">Válassz helyszint...</option>}
              selectOptions={this.renderHelyszinOptions()}
            />
          </div>
          <div className="col-md-12">
            <RFField
              type="select"
              name="formTema"
              id="formTema"
              label="Téma: *"
              errorMessage="Kötelező mező!"
              required
              value={formTema}
              onChange={this.handleInputChange}
              autocomplete="off"
              defaultSelect={<option value="">Válassz témát...</option>}
              selectOptions={this.renderTemaOptions()}
            />
          </div>
          <div className="col-md-12" style={{ marginBottom: 10 }}>
            <Label for="formSzinkodFejlec">Fejléc: *</Label>
            <InputGroup style={{ flexWrap: 'nowrap' }}>
              <Input
                name="formSzinkodFejlec"
                id="formSzinkodFejlec"
                type="text"
                value={formSzinkodFejlec}
                style={{ width: "3000%" }}
                // disabled
                onChange={this.handleInputChange}
                required
              />
              <InputGroup addonType="append" >
                <InputGroupText
                  id='PopFejlec'
                  style={{ backgroundColor: '#' + formSzinkodFejlec, cursor: 'pointer' }}
                // onClick={() => { this.toggleElsodlegesPicker() }}
                ><i
                    style={{ color: this.getCorrectTextColor('#' + formSzinkodFejlec) }} className="icon-drop" /></InputGroupText>
              </InputGroup>
            </InputGroup>
          </div>
          <UncontrolledPopover target="PopFejlec" trigger="legacy">
            <PopoverHeader>
              Fejléc
            </PopoverHeader>
            <SketchPicker
              //width="100%"
              disableAlpha
              color={formSzinkodFejlec}
              onChange={this.handleColorFejlecChange}
              presetColors={[]}
            // presetColors={["#b50004", "#0067a7"]}
            //triangle="top-right"
            />
          </UncontrolledPopover>

          <div className="col-md-12" style={{ marginBottom: 10 }}>
            <Label for="formSzinkodLablec">Lábléc: *</Label>
            <InputGroup style={{ flexWrap: 'nowrap' }}>
              <Input
                name="formSzinkodLablec"
                id="formSzinkodLablec"
                type="text"
                value={formSzinkodLablec}
                style={{ width: "3000%" }}
                // disabled
                onChange={this.handleInputChange}
                required
              />
              <InputGroup addonType="append" >
                <InputGroupText
                  id='PopLablec'
                  style={{ backgroundColor: '#' + formSzinkodLablec, cursor: 'pointer' }}
                // onClick={() => { this.toggleElsodlegesPicker() }}
                ><i
                    style={{ color: this.getCorrectTextColor('#' + formSzinkodLablec) }} className="icon-drop" /></InputGroupText>
              </InputGroup>
            </InputGroup>
          </div>
          <UncontrolledPopover target="PopLablec" trigger="legacy">
            <PopoverHeader>
              Lábléc
            </PopoverHeader>
            <SketchPicker
              //width="100%"
              disableAlpha
              color={formSzinkodLablec}
              onChange={this.handleColorLablecChange}
              presetColors={[]}
            // presetColors={["#b50004", "#0067a7"]}
            //triangle="top-right"
            />
          </UncontrolledPopover>


          <div className="col-md-12" style={{ marginBottom: 10 }}>
            <Label for="formSzinkodElsodleges">Elsődleges szín: *</Label>
            <InputGroup style={{ flexWrap: 'nowrap' }}>
              <Input
                name="formSzinkodElsodleges"
                id="formSzinkodElsodleges"
                type="text"
                value={formSzinkodElsodleges}
                style={{ width: "3000%" }}
                // disabled
                onChange={this.handleInputChange}
                required
              />
              <InputGroup addonType="append" >
                <InputGroupText
                  id='PopElsodleges'
                  style={{ backgroundColor: '#' + formSzinkodElsodleges, cursor: 'pointer' }}
                  onClick={() => { this.toggleElsodlegesPicker() }}
                ><i
                    style={{ color: this.getCorrectTextColor('#' + formSzinkodElsodleges) }} className="icon-drop" /></InputGroupText>
              </InputGroup>
            </InputGroup>
          </div>
          <UncontrolledPopover target="PopElsodleges" trigger="legacy">
            <PopoverHeader>
              Elsődleges szín
            </PopoverHeader>
            <SketchPicker
              //width="100%"
              disableAlpha
              color={formSzinkodElsodleges}
              onChange={this.handleColorChange}
              presetColors={[]}
            // presetColors={["#b50004", "#0067a7"]}
            //triangle="top-right"
            />
          </UncontrolledPopover>
          <div className="col-md-12" style={{ marginBottom: 10 }}>
            <Label for="formSzinkodMasodlagos">Másodlagos szín: *</Label>
            <InputGroup style={{ flexWrap: 'nowrap' }}>
              <Input
                name="formSzinkodMasodlagos"
                id="formSzinkodMasodlagos"
                type="text"
                value={formSzinkodMasodlagos}
                style={{ width: "3000%" }}
                // disabled
                onChange={this.handleInputChange}
                required
              />
              <InputGroup addonType="append">
                <InputGroupText
                  id='PopMasodlagos'
                  style={{ backgroundColor: '#' + formSzinkodMasodlagos, cursor: 'pointer' }}
                  onClick={() => { this.toggleMasodlagosPicker() }}
                ><i
                    style={{ color: this.getCorrectTextColor('#' + formSzinkodMasodlagos) }} className="icon-drop" /></InputGroupText>
              </InputGroup>
            </InputGroup>
          </div>
          <UncontrolledPopover target="PopMasodlagos" trigger="legacy">
            <PopoverHeader>
              Másodlagos szín
            </PopoverHeader>
            <SketchPicker
              //width="100%"
              disableAlpha
              color={formSzinkodMasodlagos}
              onChange={this.handleColorMasodlagosChange}
              presetColors={[]}
            />
          </UncontrolledPopover>

          <div className="col-md-12" style={{ paddingTop: 10 }} >
            <Label>Logó:</Label>
            {!this.state.formLogo
              && (
                <DropZone id="formLogo" onDrop={this.onDropLogo} className="custom-dropzone" accept="image/*">
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: 'custom-dropzone' })}>
                      <input {...getInputProps()} />
                      <div className="dropzone-text">
                        {'Kép feltöltése!'}
                      </div>
                    </div>
                  )}
                  {/* <div className="dropzone-text">
                            {'Kép feltöltése!'}
                          </div> */}
                </DropZone>
                // <DropZone id="formLogo" onDrop={this.onDropLogo} className="custom-dropzone" accept="image/*">
                //   <div className="dropzone-text">
                //     {'Kép feltöltése!'}
                //   </div>
                // </DropZone>
              )
            }
            {this.state.formLogo
              && (
                <ImageCard
                  mime={this.state.formLogo.mime}
                  content={this.state.formLogo.content}
                  src={this.state.formLogo.src}
                  poster
                  onViewClick={this.toggleLogoModal}
                  onDeleteClick={() => { this.setState({ formLogo: null }); }}
                />
              )
            }
          </div>
        </div>
      </React.Fragment>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
              {'Új beállítások rögzítése'}
            </Button>
          </div>
          <div className="col-md-12">
            {{
              LOAD: (<Loader />),
              DATA: (<DataEmptyState
                hasImage
                subtitle="Vigyél fel új tételt!"
              />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => { this.listPublikusSzin(); }}
              />),
              TABL: (this.renderTable())
            }[this.state.tableStatus]}
          </div>
        </div>
        <RFForm
          onSubmit={this.submitForm}
          modalInsert
          title={<span>{this.renderFormTitle()}<CustomTooltip text={getTooltip('szinmezo')} id="formSzinkodTT" /></span>}
          tagProps={{ isOpen: this.state.modalForm, toggle: this.toggleFormModal, className: this.props.className, backdrop: 'static' }}
          footer={
            <React.Fragment>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Mégsem</Button>
            </React.Fragment>
          }
        >
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => { }}
            />),
            DATA: (this.renderForm())
          }[this.state.formStatus]}
        </RFForm>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánja a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deletePublikusSzin()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

PubszinContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default PubszinContent;
